<template>
  <v-chip
    small
    :color="color"
    :text-color="textColor"
    :outlined="outlined"
    class="customer-status-badge"
  >
    <v-icon left x-small>{{ icon }}</v-icon>
    {{ label }}
  </v-chip>
</template>

<script>
export default {
  name: 'CustomerStatusBadge',

  props: {
    status: {
      type: String,
      required: true,
      validator: (value) => {
        return ['active', 'pending-verification', 'suspended-admin', 'pending-deletion', 'deleted'].includes(value)
      }
    }
  },

  computed: {
    label() {
      const labels = {
        'active': this.$t('customer.status.active'),
        'pending-verification': this.$t('customer.status.pending-verification'),
        'suspended-admin': this.$t('customer.status.suspended'),
        'pending-deletion': this.$t('customer.status.pending-deletion'),
        'deleted': this.$t('customer.status.deleted')
      }
      return labels[this.status] || this.status
    },

    color() {
      const colors = {
        'active': 'success',
        'pending-verification': 'info',
        'suspended-admin': 'warning',
        'pending-deletion': 'orange',
        'deleted': 'error'
      }
      return colors[this.status] || 'grey'
    },

    textColor() {
      return 'white'
    },

    outlined() {
      return false
    },

    icon() {
      const icons = {
        'active': 'mdi-check-circle',
        'pending-verification': 'mdi-clock-outline',
        'suspended-admin': 'mdi-pause-circle',
        'pending-deletion': 'mdi-delete-clock',
        'deleted': 'mdi-delete'
      }
      return icons[this.status] || 'mdi-help-circle'
    }
  }
}
</script>

<style lang="scss" scoped>
.customer-status-badge {
  font-weight: 500;
}
</style>
